import CmiDataMapper from './CmiDataMapper'

export default CmiDataMapper
